import { render, staticRenderFns } from "./AdCopy.vue?vue&type=template&id=e934a84e&scoped=true"
import script from "./AdCopy.vue?vue&type=script&lang=js"
export * from "./AdCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e934a84e",
  null
  
)

export default component.exports